// state
import axios from "axios";
import commonservice from "../../../shared/common.service";

const defaultState = () => ({
  entity: {
    id: null,
    contentId: null,
    departureDate: null,
    fixedPax: null,
    maxGroupSize: null,
    totalDays: null,
    remarks: null
  }
});

const state = defaultState();
// getters
const getters = {};

// actions
const actions = {
  loadFixedDeparture({ state }, { pagination, search }) {
    return new Promise((resolve, reject) => {
      var param = {
        descending:
          pagination.sortDesc.length > 0 ? pagination.sortDesc[0] : false,
        page: pagination.page,
        rowsPerPage: pagination.itemsPerPage,
        sortBy: pagination.sortBy.length > 0 ? pagination.sortBy[0] : "name",
        search: search,
        contentId: state.entity.contentId
      };
      axios
        .get("/fixeddeparture?" + commonservice.convertToQueryString(param))
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  setFixedDeparture({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/fixeddeparture/" + id)
        .then(response => {
          commit("SET_FIXED_DEPARTURE", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  save({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.entity.id) {
        axios
          .patch("/fixeddeparture", state.entity)
          .then(
            response => {
              commit("RESET");
              resolve(response);
            },
            error => {
              reject(error);
            }
          )
          .catch(error => {
            reject(error);
          });
      } else {
        axios
          .post("/fixeddeparture", state.entity)
          .then(
            response => {
              commit("RESET");
              resolve(response);
            },
            error => {
              reject(error);
            }
          )
          .catch(error => {
            reject(error);
          });
      }
    });
  },
  deleteFixedDeparture({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      axios
        .delete("/fixeddeparture/" + id)
        .then(response => {
          commit("RESET");
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

// mutations
const mutations = {
  RESET(state) {
    const contentId = state.entity.contentId;
    Object.assign(state, defaultState());
    state.entity.contentId = contentId;
  },
  SET_FIXED_DEPARTURE_DATA(state, data) {
    if (Object.prototype.toString.call(state[data.key]) === "[object Array]") {
      state[data.key][data.index][data.property] = data.value;
    } else if (
      Object.prototype.toString.call(state[data.key]) === "[object Object]"
    ) {
      state[data.key][data.property] = data.value;
    } else state.entity[data.key] = data.value;
  },
  SET_FIXED_DEPARTURE(state, data) {
    state.entity.id = data.id;
    state.entity.fixedPax = data.fixedPax;
    state.entity.maxGroupSize = data.maxGroupSize;
    state.entity.departureDate = data.departureDate;
    state.entity.totalDays = data.totalDays;
    state.entity.remarks = data.remarks;
    state.entity.contentId = data.contentId;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
